import { useState } from "react";
import useDecodeToken from "../../hooks/useDecodeToken";
import { cn } from "../../helpers/cn";
import {
  hasAccessToDedicated,
  hasAccessToNetwork,
} from "../../services/accountService";

function ServiceTypeToggle({ mode: initialMode = "dedicated", onChangeMode }) {
  const [decodeToken] = useDecodeToken();
  const [mode, setMode] = useState(initialMode); // mode: "dedicated" or "network"
  // const { IsDedicatedClient, IsNetworkClient } = decodeToken || {};

  if (!(hasAccessToDedicated(decodeToken) && hasAccessToNetwork(decodeToken))) {
    return null;
  }

  return (
    <div>
      <div className="tw-flex tw-items-center tw-flex-col tw-gap-0">
        <label
          htmlFor="check"
          className={cn(
            "tw-cursor-pointer tw-relative tw-w-12 tw-h-6 tw-rounded-full tw-border tw-border-gray-200 tw-border-solid tw-transition-all tw-duration-300 tw-m-0",
            mode === "dedicated" ? "tw-bg-sky-500" : "tw-bg-white"
          )}
        >
          <input
            type="checkbox"
            id="check"
            className="tw-sr-only"
            onClick={() => {
              const newMode = mode === "dedicated" ? "network" : "dedicated";
              setMode(newMode);
              onChangeMode?.(newMode);
            }}
          />
          <span
            className={cn(
              "tw-w-2/5 tw-h-4/5 tw-absolute tw-rounded-full tw-top-0.5 tw-transition-all tw-duration-300",
              mode === "dedicated"
                ? "tw-bg-white tw-left-6"
                : "tw-bg-gray-400 tw-left-1"
            )}
          />
        </label>

        <span
          key={mode === "dedicated" ? "on" : "off"}
          className="tw-font-medium tw-transition-opacity tw-duration-300 tw-ease-in-out tw-opacity-100"
        >
          {mode === "dedicated" ? "Dedicated" : "Network"} Mode
        </span>
      </div>
    </div>
  );
}

export default ServiceTypeToggle;
